import { UserCreate } from 'client/voladeum/users/types';

export const user_create_default: UserCreate = {
  first_name: '',
  last_name: '',
  email: '',
  user_name: '',
  password: '',
};
